import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    placeholder: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Placeholder text for the project search field in the project switcher sheet */
            placeholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetSearch.placeholder?c=3cogn8pa3dn64", defaultMessage: "Search projects" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
